import {useMutation} from "@tanstack/react-query";
import {stripeApplyPromoUrl} from "../../constants/api/endpoints";
import {useAxios} from "../../hooks/axios/useAxios";
import {toast} from "react-toastify";

export const useMutateApplyPromo = ({payment_intent_id} : {payment_intent_id?: string}) => {
  const axios = useAxios();

  async function postData(data: { promo_code: string }) {
    return axios.post(stripeApplyPromoUrl,
      {
        ...data,
        payment_intent_id
      }
    )
      .then(response => response?.data)
  }

  return useMutation({
    mutationKey: ['apply-promo', payment_intent_id],
    mutationFn: postData,
    retry: 1,
    onSuccess: () => toast.success('Promo code applied!'),
    onError: (error) => {
      // @ts-ignore
      toast.error(error?.response?.data?.error ?? 'Invalid promo code.')
    }
  });
}
